import { useState, useEffect } from 'react';
import { clientLogger } from "@/lib/client-logger";

export interface MailchimpAudience {
  id: string;
  name: string;
  memberCount: number;
  dateCreated: string;
}

interface UseMailchimpAudiencesResult {
  audiences: MailchimpAudience[];
  isLoading: boolean;
  error: string | null;
  refetch: () => void;
}

export function useMailchimpAudiences(): UseMailchimpAudiencesResult {
  const [audiences, setAudiences] = useState<MailchimpAudience[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchAudiences = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await fetch('/api/mailchimp/audiences');
      const data = await response.json();

      if (response.ok && data.success) {
        setAudiences(data.audiences || []);
      } else {
        setError(data.error || 'Failed to fetch audiences');
        setAudiences([]);
      }
    } catch (err) {
      setError('Network error while fetching audiences');
      setAudiences([]);
      clientLogger.error("Error fetching Mailchimp audiences", { error: err });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAudiences();
  }, []);

  return {
    audiences,
    isLoading,
    error,
    refetch: fetchAudiences
  };
}
